import { Component, Input, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DynamicListInputs } from '../../models/dynamic-list.model';
import { ShowlistComponent } from '../list/showlist/showlist.component';

@Component({
  selector: 'app-dynamic-list',
  standalone: true,
  imports: [CommonModule, ShowlistComponent],
  templateUrl: './dynamic-list.component.html',
  styleUrl: './dynamic-list.component.scss'
})
export class DynamicListComponent implements OnInit {
  @Input() formName: string = '';
  @Input() formId: string = '';
  @Input() pageTitle: string = '';

  constructor() {
    // 如果沒有傳入 pageTitle，則使用 formName + '管理' 作為預設標題
    if (!this.pageTitle && this.formName) {
      this.pageTitle = this.formName;
    }
  }

  ngOnInit() {
    // 確保在 ngOnInit 時設定預設標題
    if (!this.pageTitle && this.formName) {
      this.pageTitle = this.formName;
    }
  }
}
